// Forked from api/msw/api/selectLists/caseTypes/index.ts at `cases-pre-sr-fork` (Service Requests start as a copy of Cases).
// Comments below were written for Cases and still describe this file until the two diverge.
import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../../decorators'
import { getServiceRequestTypeListData } from './mockData'
import type { IServiceRequestType } from '@/types/serviceRequest/models'

// get

interface GetServiceRequestTypesResponse {
  data: IServiceRequestType[]
}

async function getServiceRequestTypes(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const responseBody: GetServiceRequestTypesResponse = {
    data: await getServiceRequestTypeListData(),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

// post

const postServiceRequestType = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getServiceRequestTypeListData)
}

const patchServiceRequestType = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getServiceRequestTypeListData)
}

const deleteServiceRequestType = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getServiceRequestTypeListData)
}

export const handlers = [
  {
    method: 'get',
    path: '/api/servicerequesttypes',
    handler: getServiceRequestTypes,
  },
  {
    method: 'post',
    path: '/api/servicerequesttypes',
    handler: postServiceRequestType,
  },
  {
    method: 'patch',
    path: '/api/servicerequesttypes/:id',
    handler: patchServiceRequestType,
  },
  {
    method: 'delete',
    path: '/api/servicerequesttypes/:id',
    handler: deleteServiceRequestType,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
